import { navigate } from "astro:transitions/client";

export const LanguageSelect: React.FC<{
  value?: string;
  options: { label: string; value: string }[];
}> = ({ options, value = "" }) => {
  return (
    <select
      className="select select-bordered max-md:select-sm max-sm:hidden"
      value={value}
      onChange={(event) => {
        const url = new URL(window.location.href);
        url.searchParams.delete("page");

        if (event.target.value) {
          url.searchParams.set("language", event.target.value);
        } else {
          url.searchParams.delete("language");
        }

        navigate(url.toString());
      }}
    >
      <option value="">All languages</option>
      {options.map((option, index) => (
        <option key={index} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};
